import { AFFILIATE_URL, getAffiliateLinkProps } from '../../../constants/affiliate';

export default function StickyBanner() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      {/* Desktop sticky CTA */}
      <a
        href={AFFILIATE_URL}
        {...getAffiliateLinkProps('sticky_banner', 'Register Now')}
        className="block text-center btn-premium text-white font-bold py-3 px-3 sm:py-3.5 sm:px-4 cursor-pointer tracking-wide transition-all duration-300 animate-breathe shimmer-bg"
      >
        <span className="relative z-10 mx-auto flex max-w-full flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-[11px] leading-snug sm:text-xs md:text-sm md:gap-2 md:whitespace-nowrap">
          <i className="ri-flashlight-line shrink-0"></i>
          <span className="min-w-0 break-words">
            REGISTER NOW – DAILY DEPOSIT BONUS UP TO AUD 200
          </span>
          <i className="ri-arrow-right-line shrink-0"></i>
        </span>
      </a>
    </div>
  );
}
